export const formatAmount = (n) => {
  if (!n) return '0'
  const [int, dec] = n.toString().split('.')
  return dec ? `${int}.${dec.slice(0, 2)}` : int
}
